/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LiquidationReasonEnum {
    PaymentDelay = 'PAYMENT_DELAY',
    FalseDeclaration = 'FALSE_DECLARATION',
    ObligationDelay = 'OBLIGATION_DELAY',
    ObligationBreach = 'OBLIGATION_BREACH',
    UnsignedTransactionContract = 'UNSIGNED_TRANSACTION_CONTRACT',
    OtherBreaches = 'OTHER_BREACHES',
    ObligationCrossBreach = 'OBLIGATION_CROSS_BREACH',
    Distraint = 'DISTRAINT',
    CreditorRightsEnforced = 'CREDITOR_RIGHTS_ENFORCED'
}

export function LiquidationReasonEnumFromJSON(json: any): LiquidationReasonEnum {
    return LiquidationReasonEnumFromJSONTyped(json, false);
}

export function LiquidationReasonEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiquidationReasonEnum {
    return json as LiquidationReasonEnum;
}

export function LiquidationReasonEnumToJSON(value?: LiquidationReasonEnum | null): any {
    return value as any;
}

